import { type FC, type ReactNode } from 'react';

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { cn } from '@/lib/utils';

interface TabItem {
  key: string;
  label: ReactNode;
}

interface PillTabsProps {
  tabs: TabItem[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const PillTabs: FC<PillTabsProps> = ({ tabs, value, onChange, disabled }) => {
  return (
    <Tabs
      value={value}
      onValueChange={onChange}
      activationMode="manual"
      className="flex w-full justify-center"
    >
      <TabsList className="flex w-full justify-center gap-10 bg-transparent p-0">
        {tabs.map(({ key, label }) => (
          <TabsTrigger
            key={key}
            value={key}
            disabled={disabled}
            className={cn(
              'text-muted-foreground h-10 max-w-17 min-w-17 rounded-full transition-all',
              'group-data-[variant=default]/tabs-list:data-[state=active]:shadow-none',
              'data-[state=active]:bg-error-bg data-[state=active]:border-nav-menu-stroke data-[state=active]:text-primary dark:data-[state=active]:text-primary',
              'data-[state=inactive]:hover:bg-muted data-[state=inactive]:hover:text-muted-foreground'
            )}
          >
            {label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};

export default PillTabs;
